export default {
  container: {
    position: 'relative',
    fontSize: '30px'
  },
  editor: {
    marginTop: 'calc(-1.4em - 2px)',
    '& .public-DraftEditor-content': {
      fontSize: '14px',
      minHeight: '200px',
      paddingTop: '52px'
    }
  },
  panel: {
    background: '#f5f5f5',
    borderRadius: '4px 4px 0 0',
    margin: '1px',
    position: 'sticky',
    top: '-40px',
    padding: '.2em'
  }
}
